import React from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';

import metadata from './ContactUsPageTemplate.metadata.json5';
import { withRouter } from 'react-router-dom';
import {ViewModelForm} from "gw-portals-viewmodel-react";
import appConfig from 'app-config';
import {getImageSrc} from './../../../utils/lobIconUtil';

function ContactUsPageTemplate() {
    const renderedContentFromMetadata = renderContentFromMetadata(metadata.pageContent);

    const overrideProps = {
        Image: {
            src: getImageSrc('branding/Trillium_Secondary_Logo_Horizontal_RGB.png')
        }
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
    />
    );
}

//export default withRouter(ContactUsPageTemplate);
export default ContactUsPageTemplate;
